<template>
  <div class="flex app-content-back w-screen mt-0 align-top min-h-screen">
    <router-view />
  </div>
</template>

<script>
export default {
    name: 'TrainingLayout'
}
</script>

<style scoped>

</style>